/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".categories-summary-cell[_ngcontent-%COMP%]{padding:5px;display:flex;justify-content:stretch;align-items:flex-end}.categories-summary-cell[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-size:12px}.categories-summary-cell[_ngcontent-%COMP%]   .column[_ngcontent-%COMP%]{width:50%}.categories-summary-cell[_ngcontent-%COMP%]   .summary[_ngcontent-%COMP%]{text-align:end;font-size:16px}"];
export { styles as styles };
